export default {
  data: () => ({
    translations: {
      companyDetails: {
        el: 'ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ',
        en: 'Company Details',
        it: 'Dettagli della Compagnia',
      },
      companyName: {
        el: 'Όνομα εταιρείας',
        en: 'Company Name',
        it: 'Nome della ditta',
      },
      companyCountry: {
        el: 'Χώρα εταιρείας',
        en: 'Company Country',
        it: "Paese dell'azienda",
      },
      vatNumber: {
        el: 'Αριθμός ΑΦΜ',
        en: 'Vat Number',
        it: 'Partita IVA',
      },
      vatCountry: {
        el: 'Χώρα ΦΠΑ',
        en: 'Vat Country',
        it: 'Paese IVA',
      },
      email: {
        el: 'Email',
        en: 'Email',
        it: 'E-mail',
      },
      primaryPhone: {
        el: 'Τηλέφωνο εταιρείας',
        en: 'Primary Phone',
        it: 'Telefono principale',
      },
      loyaltyDetails: {
        el: 'Λεπτομέρειες Προγράμματος Πιστότητας',
        en: 'Loyalty Details',
        it: 'Dettagli fedeltà',
      },
      loyaltyName: {
        el: 'Όνομα Προγράμματος',
        en: 'Loyalty Name',
        it: 'Nome fedeltà',
      },
      loyaltyDescription: {
        el: 'Περιγραφή Προγράμματος',
        en: 'Loyalty Description',
        it: 'Descrizione fedeltà',
      },
      loyaltyCountry: {
        el: 'Χώρα πίστης',
        en: 'Loyalty Country',
        it: 'Paese fedeltà',
      },
      pointsLabel: {
        el: 'Ετικέτα πόντων',
        en: 'Points Label',
        it: 'Etichetta punti',
      },
      cashbackLabel: {
        el: 'Ετικέτα cashback',
        en: 'Cashback Label',
        it: 'Etichetta cashback',
      },
      createCompany: {
        el: 'Δημιουργία Εταιρείας',
        en: 'Create Company',
        it: 'Crea azienda',
      },
      backToPlanSelection: {
        en: 'Back to plan selection',
        el: 'Επιστροφή στην επιλογή πλάνου',
        it: 'Torna alla selezione del piano',
      },
    },
  }),
};
